import React, { Component, Fragment } from "react";
import Dashboard from "../../../Components/Educacao/Dashboard/index";
import Dashboardv2 from "../../../Components/Educacao/Dashboard/index_v2";
import Dashboard2v2 from "../../../Components/Educacao/Dashboard/V2/index_v2";
import Totais from "../../../Components/Educacao/Dashboard/Totais";
import TotaisV2 from "../../../Components/Educacao/Dashboard/TotaisV2";
import NomeUnidade from "../../../Components/UI/NomeUnidade";

export default class PageDashboard extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Dashboard",
            resultados: [],
            resultadosV2: [],
            escolheDash: true
        }
    }

    totais = (totais) => {
        this.setState({
            resultados: totais
        })
    }

    totaisV2 = (totais) => {
        this.setState({
            resultadosV2: totais
        })
    }

    escolherDash = () => {
        this.setState({ escolheDash: !this.state.escolheDash });
    }

    render() {
        return(
            <Fragment>
                <div className="content">
                    <NomeUnidade unidade={"Dashboard"} />
                    {this.state.escolheDash ? 
                        <Fragment>
                            <Totais resultados={this.state.resultados}/>
                            <Dashboard totais={this.totais} escolheDash={this.escolherDash} />
                        </Fragment>
                        :
                        <Fragment>
                            <TotaisV2 resultados={this.state.resultadosV2}/>
                            <Dashboardv2 totais={this.totaisV2} escolheDash={this.escolherDash} />
                        </Fragment>
                    }
                    <Dashboard2v2 />
                </div>
            </Fragment>
        )
    }
}